/**
 * Created by Ivan on 13.04.2026
 */

Placements.ENTRIES["hungryGamesFinishCompetition"] = {
    type: Placements.FREE_FOCUS,

    filter: function () {
        const mission = cleverapps.missionManager.findRunningMission(Mission.TYPE_HUNGRY_GAMES);
        return Boolean(mission && mission.logic.state === HungryGamesLogic.STATES.ACTIVE
            && mission.result >= HungryGamesLogic.LEVELS_AMOUNT);
    },

    action: function () {
        const mission = cleverapps.missionManager.findRunningMission(Mission.TYPE_HUNGRY_GAMES);
        mission.onUpdateMission(1);
    }
};

Placements.ENTRIES["hungryGamesLose"] = {
    type: Placements.FREE_FOCUS,

    filter: function () {
        const mission = cleverapps.missionManager.findRunningMission(Mission.TYPE_HUNGRY_GAMES);
        return mission && mission.logic.needShowLoseWindow;
    },

    action: function () {
        const mission = cleverapps.missionManager.findRunningMission(Mission.TYPE_HUNGRY_GAMES);
        mission.logic.showLoseWindow();
    }
};

Placements.ENTRIES["hungryGamesAdvanceLevel"] = {
    type: Placements.FREE_FOCUS,

    filter: function () {
        const mission = cleverapps.missionManager.findRunningMission(Mission.TYPE_HUNGRY_GAMES);
        return mission && mission.logic.needShowAdvanceWindow;
    },

    action: function () {
        const mission = cleverapps.missionManager.findRunningMission(Mission.TYPE_HUNGRY_GAMES);

        mission.logic.showAdvanceWindow();
    }
};
